import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeExpire'
})
export class TimeExpirePipe implements PipeTransform {

  transform(value: number): any {

      let seconds = Math.floor(value / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      hours %= 48;
      minutes %= 60;
      seconds %= 60;
      return hours + ':' + minutes + ':' + seconds;
  }

}
